<template>
    <aside>
        <div class="section-data" style="min-height: 400px;">
            <div class="title d-flex justify-content-between">
                <div class="text">
                    <div id="slot-title">
                    </div>
                    <h3 class="font-blue">Introducción</h3>
                    <p class="font-gray-dark">Introducción de publicación por Kllaar.com</p>
                </div>
                <div class="tools">
                    <div id="slot-tools">
                    </div>
                </div>
            </div>
            <div class="data">
                <div class="container my-3">
                    <div id="slot-content">
                    </div>
                    <div class="content">
                        <div class="target-downloading text-center p-1 font-gray-dark" v-if="downloading">
                            <b-spinner small label="Espere ..."></b-spinner>
                            <span class="p-1">Espere un momento...</span>
                        </div>
                        <div class="target-body text-center">
                            <div class="__tip p-4 font-gray-dark">
                                Bienvenido a la comunidad <b>Kllaar.com</b>
                                donde tu conocimiento ayudará a cientos de estudiantes a alcanzar sus objetivos.
                                Aquí podrás publicar tus cursos. Para poder llegar a <b>más estudiantes</b>
                                podrás compartir tus cursos en redes sociales, ganar <b>popularidad</b> y darte a
                                conocer entre nuestros capacitadores.
                                Gracias por unirte a <b>Kllaar.com</b>
                            </div>
                            <div class="__tols mb-5">
                                <router-link to="/curse/generate/name" class="btn shadow b-blue">Iniciar Publicación
                                </router-link>
                                <button @click="displayIntro" class="btn shadow b-blue">
                                    <i class="fas fa-question-circle"></i> Ayuda
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>
<script>
export default {
    data() {
        return {
            downloading: false,
            initialButton: false
        }
    },
    methods: {
        displayIntro() {
            this.bus.$emit('display-courses-intro')
        }
    }
}
</script>
<style lang="scss">
.target {
  margin-top: 0;
}

.section {
  &-data {
    background: #fff !important;
    -webkit-box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    border-radius: .25rem !important;

    .title {
      padding: 15px 0 0 15px;
      border-bottom: 1px solid #EEEEEE;
    }

    .data {
      .is-empty, .is-loading {
        text-align: center;
        justify-content: center;
        align-content: center;

        img {
          opacity: .5;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/#pages/curses/pages/Info2.vue